"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALL_4_SELLING_CONTENT = exports.SCX_ROUTE = exports.printStates = exports.KIND = exports.SEGMENT = exports.VIEW_OPTIONS = exports.PHONE_COLORS = void 0;
exports.PHONE_COLORS = {
    WHITE: 'white',
    BLACK: 'black',
    GREEN: 'green',
    BLUE: 'blue',
    GREY: 'grey',
    GREEN_REVERSE: 'green_reverse',
    BLUE_REVERSE: 'blue_reverse',
    GREY_REVERSE: 'grey_reverse',
    RED: 'red',
    RED_REVERSE: 'red_reverse',
    PURPLE: 'purple',
};
exports.VIEW_OPTIONS = {
    BUTTON: 'button',
    PHONE: 'phoneNumber',
};
exports.SEGMENT = {
    GP: 'gp',
    EMP: 'emp',
};
exports.KIND = {
    PHONE: 'telefono',
    C2C: 'c2c',
};
exports.printStates = [
    'SCX_CAMPAIGN_READY',
    'WM_900_READY',
    'SCX_CAMPAIGN_ERROR',
    'SCX_BACKEND_REQUEST_ERROR',
];
exports.SCX_ROUTE = {
    QA: 'https://qa.cms.col.movistar.es/static/js/scx/scx.js',
    PROD: 'https://prod.cms.col.movistar.es/static/js/scx/scx.js',
};
exports.CALL_4_SELLING_CONTENT = {
    C2C: 'te-llamamos',
    T900: 'llama-gratis',
};
//# sourceMappingURL=enums.js.map